module.exports = __webpack_public_path__ + "img/critical-send-message.156356ae.svg";